import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { toastOptions } from "../config/toast";
import { useCredencialesNotificadoresStore } from "../store/credencialesNotificadoresStore";
import { useGeneralAppStore } from "../store/generalAppStore";
import { axios } from "../utils/axios";

const useCredencialesNotificadores = () => {
  const { handlerLoading, handlerModal } = useGeneralAppStore();

  const { setCredencialesNotificadores, setCredencialNotificador, agregarCredencialNotificador } =
    useCredencialesNotificadoresStore();

  const getCredencialesNotificadores = async () => {
    handlerLoading({ loading: true, loadName: "credenciales-notificadores" });
    const response = await axios().get("/credenciales_notificadores");
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setCredencialesNotificadores(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "credenciales-notificadores" });
  };

  const getCredencialNotificador = async (id) => {
    handlerLoading({ loading: true, loadName: "credencial-notificador" });
    const response = await axios().get(`/credenciales_notificadores/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        handlerModal({ modal: true, modalName: "credencial_notificador" });
        setCredencialNotificador(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "credencial-notificador" });
  };

  const generarCredencialNotificador = async (values) => {
    handlerLoading({ loading: true, loadName: "generar-credencial-notificador" });
    const response = await axios().post("/generar_credencial", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setCredencialNotificador(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "generar-credencial-notificador" });
  };

  const regenerarCredencialNotificador = async (values) => {
    handlerLoading({ loading: true, loadName: "generar-credencial-notificador" });
    const response = await axios().post("/regenerar_credencial", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setCredencialNotificador(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "generar-credencial-notificador" });
  };

  const cargarNotificador = async (values) => {
    handlerLoading({ loading: true, loadName: "cargar-notificador" });
    const response = await axios().post("/credenciales_notificadores", values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        agregarCredencialNotificador(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "cargar-notificador" });
  };

  const deshabilitarCredencialNotificador = async (id) => {
    handlerLoading({ loading: true, loadName: "deshabilitar-credencial-notificador" });
    const response = await axios().delete(`/credenciales_notificadores/${id}`);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setCredencialNotificador(data);
        handlerModal({ modal: false, modalName: "cargar_notificador" });
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "deshabilitar-credencial-notificador" });
  };

  const habilitarCredencialNotificador = async (values) => {
    handlerLoading({ loading: true, loadName: "habilitar-credencial-notificador" });
    const response = await axios().post(`/habilitar_credencial/`, values);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setCredencialNotificador(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "habilitar-credencial-notificador" });
  };

  return {
    getCredencialesNotificadores,
    getCredencialNotificador,
    generarCredencialNotificador,
    cargarNotificador,
    regenerarCredencialNotificador,
    deshabilitarCredencialNotificador,
    habilitarCredencialNotificador,
  };
};

export default useCredencialesNotificadores;
